import React, { useState, useCallback, useEffect } from 'react';
import {
  Form,
  Input,
  Row,
  Tooltip,
  Modal,
  Button,
  Space,
  Select,
  Card,
  Tag,
  Spin,
} from 'antd';
import {
  PlusOutlined,
  DeleteOutlined,
  CaretUpOutlined,
  LoadingOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import { addRouteRules } from 'services/routeRule';
// import { leaveEditForm } from 'utils';
// import { SelectCountry } from 'components/common';
// import { queryState } from 'services/country';
// import { SelectWarehouse } from 'components/common';
import { FormLabel } from 'components/common';
import { message } from 'components/common';
import { getAllWarehouse } from 'services/warehouse';
import { getCountrys, getStates } from 'services/address';
import { sortByString } from 'utils';

interface CreateProps {
  visible: boolean;
  channels: StoreChannelRow[];
  onHide: () => void;
  onRefresh: () => void;
  nextSeq: number;
  noDefault?: boolean;
}

const CreateDialog = (props: CreateProps) => {
  const { visible, onHide, onRefresh, channels, nextSeq, noDefault } = props;
  const [loading, setLoading] = useState(false);
  const [warehouse, setWarehouse] = useState<WarehouseRow>();

  const [warehouseList, setWareHouseList] = useState<WarehouseRow[]>([]);
  const [states, setStates] = useState<string[]>([]);
  const [zips, setZips] = useState<string[]>([]);
  const [channelList, setChannelList] = useState<StoreChannelRow[]>([]);
  const [stateList, setStateList] = useState<StateRow[]>([]);
  const [countryList, setCountryList] = useState<CountryRow[]>([]);
  const [warehouses, setWarehouses] = React.useState<any[]>([]);

  const [form] = Form.useForm();

  const getWarehouses = async () => {
    try {
      const res = await getAllWarehouse();
      setWarehouses(
        res.map((item: any) => {
          return { ...item, id: item.warehouseNum, code: item.warehouseCode };
        })
      );
    } catch (error) { }
  };

  const fetchCountryList = async () => {
    try {
      setLoading(true);
      const res = await getCountrys();
      setLoading(false);
      if (res.isSuccess) {
        setCountryList(res.data);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const fetchStateList = async (id: number) => {
    try {
      setLoading(true);
      const res = await getStates(id);
      setLoading(false);
      if (res.isSuccess) {
        // setStateList(res.data);
        setStateList(res.data.sort((a:any,b:any)=> sortByString(a, b, 'code')));
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleCreate = async () => {
    const params = await form.validateFields();
    if (params.errorFields) return;
    if (warehouseList.length === 0) {
      return message.warning({ content: 'warehouse is required' });
    }
    setLoading(true);
    try {
      const addPrams = noDefault
        ? {
          RuleName: 'Default',
          Country: 'United States',
          RouteChannelList: [],
          RouteStatesList: [],
          RouteZipCodeList: [],
          Default: true,
          Seq: 1,
          RouteWarehouseList: warehouseList.map((item, index) => {
            return {
              WarehouseNum: item.id,
              Priority: index,
            };
          }),
        }
        : {
          RuleName: params.RuleName,
          Country: params.Country,
          Default: false,
          Seq: nextSeq,
          RouteWarehouseList: warehouseList.map((item, index) => {
            return {
              WarehouseNum: item.id,
              Priority: index,
            };
          }),
          RouteChannelList: channelList.map((item) => item.channelAccountNum),
          RouteStatesList: states,
          RouteZipCodeList: zips,
        };
      const result = await addRouteRules(addPrams);
      setLoading(false);
      if (result) {
        form.resetFields();
        onHide();
        onRefresh();
        message.success({ content: 'Created Rule Successfully！' });
      } else {
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const handleCancel = useCallback(async () => {
    const cancel = form.isFieldsTouched();
    if (!cancel) {
      onHide();
    } else {
      Modal.confirm({
        title: 'Leave / Refresh Page?',
        okText: 'Leave',
        cancelText: 'Cancel',
        content: `Changes you made may not be saved.`,
        onOk() {
          onHide();
        },
      });
    }
  }, [onHide, form]);

  // const handleWarehouseSelectChange = useCallback((wh: WarehouseRow) => {
  //   setWarehouse(wh);
  // }, []);
  const handleWarehouseSelectChange = useCallback(
    (id) => {
      setWarehouse(
        warehouses.filter((item) => item.warehouseNum === Number(id))[0]
      );
    },
    [warehouses]
  );

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 14 },
  };

  useEffect(() => {
    // fetchStateList();
    fetchCountryList();
    getWarehouses();
  }, []);
  return (
    <Modal
      title={noDefault ? 'Create Default Routing Rule' : 'Create Routing Rule'}
      centered
      visible={visible}
      maskClosable={false}
      bodyStyle={{ padding: 8 }}
      width={900}
      destroyOnClose
      onCancel={handleCancel}
      getContainer={false}
      footer={
        <Row justify="end">
          <Space>
            <Button
              key="submit"
              type="primary"
              onClick={handleCreate}
              loading={loading}
              icon={loading ? <LoadingOutlined /> : <PlusOutlined />}
            >
              {loading ? 'Creating' : 'Create'}
            </Button>
            <Button onClick={handleCancel} icon={<CloseOutlined />}>Cancel</Button>
          </Space>
        </Row>
      }
    >
      <Spin
        spinning={loading}
        indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
      >
        {channels.length > 0 && (
          <Form {...layout} form={form}>
            {!noDefault && (
              <Card size="small" title="Condition options">
                <Form.Item
                  name="RuleName"
                  label={<FormLabel>Rule Name</FormLabel>}
                  rules={[
                    { required: true, message: 'Please Input Rule Name!' },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="Country"
                  // initialValue="United States"
                  label={<FormLabel>Country</FormLabel>}
                  rules={[
                    { required: true, message: 'Please Select Country!' },
                  ]}
                >
                  <Select
                    showSearch
                    optionFilterProp="label"
                    onChange={(value: number, option: any) => {
                      form.setFieldsValue({
                        state: undefined,
                      });
                      fetchStateList(option.key);
                    }}
                  >
                    {countryList
                      .filter((i) => i.name === 'United States')
                      .map((item) => (
                        <Select.Option
                          key={item.countryNum}
                          value={item.name}
                          label={item.name}
                        >
                          {item.name}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
                <Form.Item label={<FormLabel>State</FormLabel>}>
                  <Form.Item name="state" noStyle>
                    <Select
                      style={{ width: 320 }}
                      showSearch
                      optionFilterProp="label"
                    >
                      {stateList.map((item, index) => (
                        <Select.Option
                          value={item.name}
                          key={`state${index}`}
                          label={item.name}
                        >
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Button
                    style={{ marginLeft: 4 }}
                    onClick={() => {
                      if (!form.getFieldValue('state')) return;
                      if (!states.includes(form.getFieldValue('state'))) {
                        setStates((prev) => [
                          ...prev,
                          form.getFieldValue('state'),
                        ]);
                      }
                      form.setFieldsValue({ state: '' });
                    }}
                  >
                    <PlusOutlined />
                    Add
                  </Button>
                </Form.Item>

                <Form.Item label={<FormLabel noColon>{''}</FormLabel>}>
                  <Card
                    bodyStyle={{ padding: 4, height: 30, overflow: 'auto' }}
                  >
                    {states.map((item) => (
                      <Tag
                        key={item}
                        closable
                        onClose={() => {
                          const a = states.filter((tag) => tag !== item);
                          setStates([...a]);
                        }}
                      >
                        {item}
                      </Tag>
                    ))}
                  </Card>
                </Form.Item>

                <Form.Item label={<FormLabel>Zip Code</FormLabel>}>
                  <Form.Item name="zip" noStyle>
                    <Input style={{ width: 320 }} />
                  </Form.Item>
                  <Button
                    style={{ marginLeft: 4 }}
                    onClick={() => {
                      if (!form.getFieldValue('zip')) return;
                      if (!zips.includes(form.getFieldValue('zip'))) {
                        setZips((prev) => [...prev, form.getFieldValue('zip')]);
                      }
                      form.setFieldsValue({ zip: undefined });
                    }}
                  >
                    <PlusOutlined />
                    Add
                  </Button>
                </Form.Item>

                <Form.Item label={<FormLabel noColon>{''}</FormLabel>}>
                  <Card
                    bodyStyle={{ padding: 4, height: 30, overflow: 'auto' }}
                  >
                    {zips.map((item) => (
                      <Tag
                        key={item}
                        closable
                        onClose={() => {
                          const a = zips.filter((tag) => tag !== item);
                          setZips([...a]);
                        }}
                      >
                        {item}
                      </Tag>
                    ))}
                  </Card>
                </Form.Item>

                <Form.Item label={<FormLabel>Store Account</FormLabel>}>
                  <Form.Item name="channel" noStyle>
                    <Select
                      showSearch
                      optionFilterProp="label"
                      style={{ width: 320 }}
                    >
                      {channels.map((item) => (
                        <Select.Option
                          value={item.channelAccountNum}
                          key={`account${item.channelAccountNum}`}
                          label={item.channelAccountName}
                        >
                          {item.channelAccountName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Button
                    style={{ marginLeft: 4 }}
                    onClick={() => {
                      if (!form.getFieldValue('channel')) return;
                      const a = channelList.map((item) => {
                        return item.channelAccountNum;
                      });

                      if (!a.includes(form.getFieldValue('channel'))) {
                        setChannelList((prev) => [
                          ...prev,
                          channels.filter(
                            (i) =>
                              i.channelAccountNum ===
                              form.getFieldValue('channel')
                          )[0],
                        ]);
                      }
                      form.setFieldsValue({ channel: '' });
                    }}
                  >
                    <PlusOutlined />
                    Add
                  </Button>
                </Form.Item>

                <Form.Item label={<FormLabel noColon>{''}</FormLabel>}>
                  <Card
                    bodyStyle={{ padding: 4, height: 30, overflow: 'auto' }}
                  >
                    {channelList.map((item) => (
                      <Tag
                        key={item.channelAccountName}
                        closable
                        onClose={() => {
                          const a = channelList.filter(
                            (tag) =>
                              tag.channelAccountNum !== item.channelAccountNum
                          );
                          setChannelList([...a]);
                        }}
                      >
                        {item.channelAccountName}
                      </Tag>
                    ))}
                  </Card>
                </Form.Item>
              </Card>
            )}
            <Card size="small" title="Priority" style={{ marginTop: 10 }}>
              <Form.Item label={<FormLabel>Warehouse</FormLabel>}>
                <Form.Item name="warehouse" noStyle>
                  {/* <SelectWarehouse
                    width={160}
                    placeholder="Select Warehouse"
                    onChange={handleWarehouseSelectChange}
                  /> */}
                  <Select
                    style={{ width: 320 }}
                    onChange={handleWarehouseSelectChange}
                    showSearch
                    optionFilterProp="label"
                  >
                    {warehouses.map((item) => (
                      <Select.Option
                        key={item.id}
                        value={item.id}
                        label={item.code}
                      >
                        {item.code}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Button
                  style={{ marginLeft: 4 }}
                  onClick={() => {
                    if (!warehouse) return;
                    const a = warehouseList.map((item) => item.id);
                    if (!a.includes(warehouse.id)) {
                      setWareHouseList((prov) => [...prov, warehouse]);
                    }
                    form.setFieldsValue({ warehouse: '' });
                  }}
                >
                  <PlusOutlined />
                  Add
                </Button>
              </Form.Item>

              <Form.Item label={<FormLabel noColon>{''}</FormLabel>}>
                <Card bodyStyle={{ padding: 4, height: 50, overflow: 'auto' }}>
                  {warehouseList.map((item, index) => (
                    <Row
                      key={`warehouse${index}`}
                      justify="space-between"
                      style={{ marginBottom: 3 }}
                    >
                      <Tag
                        onClose={() => {
                          const a = warehouseList.filter(
                            (tag) => tag.id !== item.id
                          );
                          setWareHouseList([...a]);
                        }}
                      >
                        {item.code}
                      </Tag>
                      <Space>
                        {index !== 0 && (
                          <Tooltip
                            title="Increase priority"
                            placement="topRight"
                          >
                            <Button
                              icon={<CaretUpOutlined />}
                              onClick={() => {
                                setWareHouseList((prev) => {
                                  const t = [...prev];
                                  const temp = t[index];
                                  t[index] = t[index - 1];
                                  t[index - 1] = temp;
                                  return [...t];
                                });
                              }}
                            />
                          </Tooltip>
                        )}
                        <Tooltip title="Remove Item" placement="topRight">
                          <Button
                            icon={<DeleteOutlined />}
                            onClick={() => {
                              const a = warehouseList.filter(
                                (tag) => tag.id !== item.id
                              );
                              setWareHouseList([...a]);
                            }}
                          />
                        </Tooltip>
                      </Space>
                    </Row>
                  ))}
                </Card>
              </Form.Item>
            </Card>
          </Form>
        )}
      </Spin>
    </Modal>
  );
};

export default CreateDialog;
